/*
{%- comment -%} section or block template {%- endcomment -%}
<ul id="shop-event-list"></ul>
*/


(async function renderEvents() {
  const endpoint = "https://www.mikihouse.com/shop/api/public/events?lang=ja&expand&limit=5";
  const list = document.getElementById("shop-event-list");
  if (!list) return;

  const esc = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

  const getEventPeriodText = (stores) => {
    if (!Array.isArray(stores) || stores.length === 0) {
      return "開催日未定";
    }

    const firstStore = stores[0] || {};
    return String(firstStore?.display_period?.ja || "開催日未定");
  };

  const getStoreText = (stores) => {
    if (!Array.isArray(stores) || stores.length === 0) return "店舗情報なし";
    if (stores.length === 1) return stores[0]?.name?.ja || "店舗情報なし";
    return "複数店舗";
  };

  const getPeriodText = (stores) => {
    if (!Array.isArray(stores) || stores.length === 0) return "開催日未定";
    if (stores.length === 1) return String(stores[0]?.display_period?.ja || "開催日未定");

    const firstPeriod = String(stores[0]?.display_period?.ja || "");
    const allSame = stores.every((store) => String(store?.display_period?.ja || "") === firstPeriod);
    return allSame ? firstPeriod : "店舗によって異なります";
  };

  try {
    const res = await fetch(endpoint, { method: "GET" });
    if (!res.ok) throw new Error("HTTP " + res.status);

    const events = await res.json();
    if (!Array.isArray(events)) throw new Error("レスポンス形式が想定外");

    list.innerHTML = events.map((eventItem) => {
      const eventCode = esc(eventItem?.event_code || "");
      const eventName = esc(eventItem?.name?.ja || "");
      const stores = Array.isArray(eventItem?.stores) ? eventItem.stores : [];
      const firstStore = stores[0] || {};
      const storeCode = esc(
        firstStore?.store_code ||
        firstStore?.code ||
        eventItem?.store_code ||
        ""
      );

      const periodText = esc(getPeriodText(stores));
      const storeText = esc(getStoreText(stores));
      const titleText = stores.length > 1 ? eventName : (storeText + "◆" + eventName);
      const href = stores.length === 1 && storeCode
        ? "https://www.mikihouse.com/shop/ja/detail/" + storeCode + "#event_" + eventCode
        : "https://www.mikihouse.com/shop/ja/events/detail/" + eventCode;

      return ''
        + "<li>"
        + '  <div class="my-article__body">'
        + '      <div class="my-article__date"><time>' + periodText + "</time></div>"
        + '      <a href="' + href + '" target="_blank" rel="noopener noreferrer"><span class="my-article__title">' + titleText + " を開催いたします。</span></a>"
        + "  </div>"
        + "</li>";
    }).join("");
  } catch (err) {
    console.error("イベント取得エラー:", err);
    list.innerHTML = "<li>イベント情報の取得に失敗しました。</li>";
  }
})();